"use client";
export const CONTACT_SECTION_CONSTANTS = {
  FORM: "contact-form",
  BOOK: "calendar-booking",
};
